import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { urlApi } from '../utils/apiConfig';


@Injectable({
  providedIn: 'root'
})
export class LoginServiceService {
  constructor(private http: HttpClient) {}


  public loginAdmin(username: string, password: string): Observable<any> {

    const body = {username, password} ;


    return this.http.post(urlApi+'/adm',body,{headers: {'Content-Type': 'application/json'}})
  }

  public loginCliente(email: string, password: string): Observable<any>{
   
    const body = {email, password} ;
    return this.http.post(urlApi+'/login',body,{headers: {'Content-Type': 'application/json'}, observe: 'response'})
  }
}
